import { render, staticRenderFns } from "./productAside.vue?vue&type=template&id=51923712&"
import script from "./productAside.vue?vue&type=script&lang=js&"
export * from "./productAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51923712')) {
      api.createRecord('51923712', component.options)
    } else {
      api.reload('51923712', component.options)
    }
    module.hot.accept("./productAside.vue?vue&type=template&id=51923712&", function () {
      api.rerender('51923712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/productAside.vue"
export default component.exports